import React from 'react';
import classNames from 'classnames';
import AddonCard from '../AddonCard';
import { FieldRenderProps } from 'react-final-form';
import { MEDIA_PACKAGE } from 'models/Listing';
import { MEDIA_PACKAGE_DATA } from '../../data';
import { useTranslation } from 'react-i18next';
import { CollapsibleSection } from 'components/CollapsibleSection';
import ShieldInfoIcon from 'icons/ShieldInfo.icon';

import './FieldMediaPackages.styles.scss';
import './FieldMediaPackages.styles.responsive.scss';

type FieldMediaPackagesProps = {
  className?: string;
  customOnChange?: (value: string) => void;
} & FieldRenderProps<string, HTMLElement>;

const options = Object.values(MEDIA_PACKAGE);

const FieldMediaPackages: React.FC<FieldMediaPackagesProps> = (props) => {
  const {
    className,
    input: { value, onChange },
    customOnChange,
  } = props;

  const classes = classNames('field-media-packages', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <CollapsibleSection
        className={classes}
        defaultOpen={!!value}
        trigger={
          <div className="field-media-packages__trigger">
            <p>{t('optionalMediaPackages')}</p>
            <p>{t('mediaPackagesDescription')}</p>
          </div>
        }
      >
        <div className="field-media-packages__content">
          <div className="left" />

          <div className="right">
            <div className="how-it-works">
              <span>
                <ShieldInfoIcon />
              </span>
              <div>
                <p>{t('howItWorks')}:</p>
                <p>{t('howItWorksDescription')}</p>
              </div>
            </div>
            {options.map((option) => (
              <AddonCard
                key={option}
                isSelected={value === option}
                onClick={() => {
                  const newValue = value === option ? '' : option;
                  onChange(newValue);
                  customOnChange?.(newValue);
                }}
                {...MEDIA_PACKAGE_DATA[option]}
              />
            ))}
          </div>
        </div>
      </CollapsibleSection>
    </div>
  );
};

export default FieldMediaPackages;
